import React from 'react';
import { Page, Icon, Link, Row, Col } from 'framework7-react';

export default function FoodlistingPage() {
  return (
    <Page className='bg-white'>
      <div className="container container-table custom-web ">
        <div className="row vertical-center-row col-md-12 col-md-offset-12">
          <header className="section-t-space">
            <div className="custom-container p-0">
              <div className="header-panel">
                <Link href="#" back reloadAll><Icon ios="material:keyboard_arrow_left" aurora="material:keyboard_arrow_left" md="material:keyboard_arrow_left" className='theme-dark' backLink="Back" ></Icon></Link>
                <h2>Food Listing</h2>
              </div>
            </div>
          </header>

          <section className="products section-t-space section-b-space">
            <div className="custom-container p-0">
                <Row>
                  <Col>
                    <div className="product-box product-box-bg mt-5 mb-3">
                      <a href="details.html" className="product-box-img">
                        <img className="img-fluid" src="https://themes.pixelstrap.com/zomo-app/assets/images/product/p1.png" alt="p1" />
                      </a>
                      <div className="product-box-detail">
                        <h5>Chicken karahi</h5>
                        <ul className="timing">
                          <li>
                            <span className="star"><i className="ri-star-s-fill" /></span> 3.7
                          </li>
                          <li>20 min</li>
                        </ul>
                        <div className="bottom-panel">
                          <div className="price">$19.23</div>
                          <a href="#" className="cart mb-0">
                            <Icon ios="material:shopping_cart" aurora="material:shopping_cart" md="material:shopping_cart" size={14}></Icon>
                          </a>
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col>
                    <div className="product-box product-box-bg mt-5 mb-3">
                      <a href="details.html" className="product-box-img">
                        <img className="img-fluid" src="https://themes.pixelstrap.com/zomo-app/assets/images/product/p2.png" alt="p2" />
                      </a>
                      <div className="product-box-detail">
                        <h5>Mexican Pizza</h5>
                        <ul className="timing">
                          <li>
                            <span className="star"><i className="ri-star-s-fill" /></span> 4.5
                          </li>
                          <li>20 min</li>
                        </ul>
                        <div className="bottom-panel">
                          <div className="price">$9.5</div>
                          <a href="#" className="cart mb-0">
                            <Icon ios="material:shopping_cart" aurora="material:shopping_cart" md="material:shopping_cart" size={14}></Icon>
                          </a>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
                <Row noGap>
                  <Col>
                    <div className="product-box product-box-bg mt-5 mb-3">
                      <a href="details.html" className="product-box-img">
                        <img className="img-fluid" src="https://themes.pixelstrap.com/zomo-app/assets/images/product/p5.png" alt="p1" />
                      </a>
                      <div className="product-box-detail">
                        <h5>Chicken karahi</h5>
                        <ul className="timing">
                          <li>
                            <span className="star"><i className="ri-star-s-fill" /></span> 3.7
                          </li>
                          <li>20 min</li>
                        </ul>
                        <div className="bottom-panel">
                          <div className="price">$19.23</div>
                          <a href="#" className="cart mb-0">
                            <Icon ios="material:shopping_cart" aurora="material:shopping_cart" md="material:shopping_cart" size={14}></Icon>
                          </a>
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col>
                    <div className="product-box product-box-bg mt-5 mb-3">
                      <a href="details.html" className="product-box-img">
                        <img className="img-fluid" src="https://themes.pixelstrap.com/zomo-app/assets/images/product/p6.png" alt="p2" />
                      </a>
                      <div className="product-box-detail">
                        <h5>Mexican Pizza</h5>
                        <ul className="timing">
                          <li>
                            <span className="star"><i className="ri-star-s-fill" /></span> 4.5
                          </li>
                          <li>20 min</li>
                        </ul>
                        <div className="bottom-panel">
                          <div className="price">$9.5</div>
                          <a href="#" className="cart mb-0">
                            <i className="ri-shopping-cart-2-fill" />
                          </a>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
                <Row noGap>
                  <Col>
                    <div className="product-box product-box-bg mt-5 mb-3">
                      <a href="details.html" className="product-box-img">
                        <img className="img-fluid" src="https://themes.pixelstrap.com/zomo-app/assets/images/product/p3.png" alt="p1" />
                      </a>
                      <div className="product-box-detail">
                        <h5>Chicken karahi</h5>
                        <ul className="timing">
                          <li>
                            <span className="star"><i className="ri-star-s-fill" /></span> 3.7
                          </li>
                          <li>20 min</li>
                        </ul>
                        <div className="bottom-panel">
                          <div className="price">$19.23</div>
                          <a href="#" className="cart mb-0">
                            <i className="ri-shopping-cart-2-fill" />
                          </a>
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col>
                    <div className="product-box product-box-bg mt-5 mb-3">
                      <a href="details.html" className="product-box-img">
                        <img className="img-fluid" src="https://themes.pixelstrap.com/zomo-app/assets/images/product/p4.png" alt="p2" />
                      </a>
                      <div className="product-box-detail">
                        <h5>Mexican Pizza</h5>
                        <ul className="timing">
                          <li>
                            <span className="star"><i className="ri-star-s-fill" /></span> 4.5
                          </li>
                          <li>20 min</li>
                        </ul>
                        <div className="bottom-panel">
                          <div className="price">$9.5</div>
                          <a href="#" className="cart mb-0">
                            <i className="ri-shopping-cart-2-fill" />
                          </a>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>        
          </section> 
        </div>     
      </div>     
    </Page>
  );
}
